import * as Yup from "yup"

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

export const validations=Yup.object({
    name:Yup.string().min(3).max(25).required("Please enter name"),
    email:Yup.string().email("Pleae enter valid email"),
    phoneNumber: Yup.string().matches(phoneRegExp, 'Phone number is not valid').required("Please enter phone no."),
    country: Yup.string(),
    organisation:Yup.string(),

});


